//Enums especiales:
export class EsquinasWidgets {
    static posDiv = "posDiv";
    static posManual = "posManual";
    static topLeftDown = "topLeftDown";
    static topRightLeft = "topRightLeft";
    static topRightDown = "topRightDown";
    static bottomLeftRight = "bottomLeftRight";
    static bottomLeftUp = "bottomLeftUp";
    static esquinasLeft = [this.topLeftDown, this.bottomLeftRight, this.bottomLeftUp];
    static esquinasRight = [this.topRightLeft, this.topRightDown];
}

//Generales:
export class ExpandsWidgetsButtons{
    constructor(expands, widgets, buttons){
        this.expands = expands;
        this.widgets = widgets;
        this.buttons = buttons;
    }
}
export class Buttons { //Para widgets que no tienen expands asociados
    constructor(cleanLayerList){
        this.cleanLayerList = cleanLayerList;
    }
}
export class Widgets { //Para widgets que no tienen expands asociados
    constructor(home, zoom, fullScreen){
        this.home = home;
        this.zoom = zoom;
        this.fullScreen = fullScreen;
    }
}
export class Expands{
    constructor(layerList, legend, search, sketch, print, cerca, filtro, basemapGallery, info, tablero){
        this.layerList = layerList;
        this.legend = legend;
        this.search = search;
        this.sketch = sketch;
        this.print = print;
        this.cerca = cerca;
        this.filtro = filtro;
        this.basemapGallery = basemapGallery;
        this.info = info;
        this.tablero = tablero;
    }
}
export class PropiedadesAdicionalesWidget { //Aplica para CustomWidget y para widgets de ESRI
    constructor(posWidget, posExpand, expandIconClass, expandTooltip, persistencia = null, labelsCambiar = null){
        this.posWidget = posWidget;
        this.posExpand = posExpand;
        this.expandIconClass = expandIconClass;
        this.expandTooltip = expandTooltip;
        this.persistencia = persistencia;
        this.labelsCambiar = labelsCambiar;
        this.expandsTraslapos = null;
        this.popupTraslapo = false;
    }
}
export class CustomWidgetsRefs {
    constructor(cerca, filtro, info, tablero, infoLayer){
        this.cerca = cerca;
        this.filtro = filtro;
        this.info = info;
        this.tablero = tablero;
        this.infoLayer = infoLayer;
    } 
}
export class PosWidget {
    constructor(esquina, posRel = null, dobleLinea = false){
        this.esquina = esquina;
        this.posRel = posRel;
        this.dobleLinea = dobleLinea;
    } 
}
export class ConfiguracionWidget {
    constructor(expressionInfo, parametrosAdicionales){
        this.expressionInfo = expressionInfo;
        this.parametrosAdicionales = parametrosAdicionales;
    }
}
export class LabelCambiar {
    constructor(atributo, valorAtributo, textoLabel){
        this.atributo = atributo;
        this.valorAtributo = valorAtributo;
        this.textoLabel = textoLabel;
    } 
}

//De componentes
export class ElementoListaFiltro {
    constructor(valor, label, seleccionado){
        this.valor = valor;
        this.label = label;
        this.seleccionado = seleccionado;
    } 
}